export const displaySubtitleMarkupText = (markup: any) => {
  return markup;
};
